import SvgIcon from '@carrier-io/air-react/SvgIcon';

function HomeIcon() {
  return (
    <SvgIcon>
      <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
    </SvgIcon>
  );
}

export default HomeIcon;
